// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Do-w","toggle":"styles_toggle__3zYcK","preview":"styles_preview__24KQx"};